import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,_vm._g(_vm._b({attrs:{"item-text":"descricao","item-value":"id","items":_vm.items},model:{value:(_vm.CODIGO_SELECIONADO_COMPUTED),callback:function ($$v) {_vm.CODIGO_SELECIONADO_COMPUTED=$$v},expression:"CODIGO_SELECIONADO_COMPUTED"}},'v-autocomplete',_vm.$attrs,false),_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }